<template>
    <div>
        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>

        <div v-else>
        <vue-headful :title="user.FirstName + ' :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/dev/accounts`">
                            <i class="fa fa-key"></i> MeritEHS Accounts
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/dev/accounts/view/${user.SmartBizClientId}`">
                            {{ user.ClientName }}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">
                        {{ user.FirstName }} {{ user.LastName }}
                        <img :src="user.brand_logo" />
                    </li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-xl-8 col-lg-12">
                    <div class="card mb-3">
                        <div class="card-header">
                            User: <strong>{{ user.FirstName }} {{ user.LastName }}</strong>
                            <div class="float-right">
                                <router-link :to="`/dev/users/edit/${user.UserId}`" class="btn btn-sm btn-light">
                                    <i class="fa fa-edit"></i> Edit
                                </router-link>
                                <a :href="`/users/impersonate/${user.UserId}`" class="btn btn-sm btn-warning" title="Impersonate this user">
                                    <i class="fa fa-group"></i> Impersonate
                                </a>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="row mb-2">
                                        <div class="col-lg-4 text-muted">Name:</div>
                                        <div class="col-lg-8 col">{{ user.FirstName }} {{ user.LastName }}</div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-lg-4 text-muted">Created:</div>
                                        <div class="col-lg-8 col">{{ user.created_at | moment("timezone", userTimezone, "MM/DD/YYYY hh:mm A") }}</div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-lg-4 text-muted">Active:</div>
                                        <div class="col-lg-8 col">
                                            <label class="badge badge-success" v-if="user.IsActive">Active</label>
                                            <label class="badge badge-warning" v-else>Inactive</label>
                                        </div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-lg-4 text-muted">Developer:</div>
                                        <div class="col-lg-8 col">
                                            <label class="badge badge-warning" v-if="user.IsDev">Developer</label>
                                        </div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-lg-4 text-muted">Email:</div>
                                        <div class="col-lg-8 col">{{ user.email }}</div>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="row mb-2">
                                        <div class="col-lg-4 text-muted">Last Login:</div>
                                        <div class="col-lg-8 col">{{ user.LastLoginDate | moment("timezone", userTimezone, "MM/DD/YYYY hh:mm A") }}</div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-lg-4 text-muted">Deleted:</div>
                                        <div class="col-lg-8 col">{{ user.deleted_at | moment("timezone", userTimezone, "MM/DD/YYYY hh:mm A") }}</div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-lg-4 text-muted">Account Domain:</div>
                                        <div class="col-lg-8 col">{{ user.user_domain }}</div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-lg-4 text-muted">Login Type:</div>
                                        <div class="col-lg-8 col">{{ user.login_type }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-12">
                    <div class="card mb-3">
                        <div class="card-header"><strong><i class="fa fa-lock"></i> Roles</strong></div>
                        <div class="card-body">
                            <div class="align-items-center" v-for="role in user.roles">
                                <div class="badge badge-secondary mt-1 mr-1">{{ role.name }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ul class="search-nav nav nav-tabs tabs-alt container-p-x container-m--x mb-4">
                <b-nav-item :active="curTab === 'loginHistory'" @click="curTab = 'loginHistory'">
                    <i class="fa fa-clock"></i> Login History
                </b-nav-item>
            </ul>

            <div v-if="curTab === 'loginHistory'">
                <div class="card">
                    <div class="card-body">
                        <v-server-table ref="userTable" :url="`/dev/users/logins/${user.UserId}`" :columns="columns" :options="options">

                            <template slot="LoginDate" slot-scope="props">
                                {{ props.row.LoginDate | moment("timezone", userTimezone, "MM/DD/YYYY hh:mm A") }}
                            </template>

                        </v-server-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment-timezone';

    export default {
        data: function() {
            return {
                curTab: 'loginHistory',
                loading: true,
                UserId: this.$route.params.id,
                user: {},
                userTimezone: this.$store.state.user.timezone,
                columns: ['LoginDate'],
                options: {
                    headings: {
                        LoginDate: 'Date',
                    },
                    orderBy: {
                        ascending: false,
                        column: 'login.LoginDate',
                    },
                    uniqueKey: 'LoginId',
                },
            }
        },

        computed: {

        },

        methods: {

            getUser: function() {
                //Get the data
                this.$http
                    .get('dev/users/view/' + this.UserId)
                    .then(response => {
                        //Set all the data
                        this.user = response.data.user;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

        },
        mounted() {
            //Get the HSE
            this.getUser();
        }
    }
</script>
